import {ExtractPropTypes} from 'vue';
import defaults, {Options} from './options';
import CurrencyNumber from './CurrencyNumber';
import {fixed, numbersToCurrency, onlyNumbers,} from './Utils';

export default function unformat(
  input: string,
  opt: Options | ExtractPropTypes<never> = defaults,
): string | number {

  if (!opt.disableNegative && input === '-') {
    return input;
  }

  const negative = opt.disableNegative ? '' : (input.indexOf('-') >= 0 ? '-' : '');

  const filtered = input.replace(opt.prefix, '');
  const numbers = onlyNumbers(filtered);
  const bigNumber = new CurrencyNumber(negative + numbersToCurrency(numbers, opt.precision));

  if (opt.max) {
    if (bigNumber > opt.max) {
      bigNumber.setNumber(opt.max);
    }
  }
  if (opt.min && opt.roundToMinValue) {
    if (bigNumber < opt.min) {
      bigNumber.setNumber(opt.min);
    }
  }

  return bigNumber.toFixed(fixed(opt.precision));
}
